// Adónde volver tras iniciar sesión o darse de alta (p. ej. el enlace de un
// torneo compartido por WhatsApp). localStorage y no sessionStorage: el correo
// de confirmación del alta abre otra pestaña. Caduca a las 24 h.
const KEY = 'level_return_url'

export function saveReturn(path) {
  try { localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() })) } catch { /* sin almacenamiento */ }
}

export function takeReturn() {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    localStorage.removeItem(KEY)
    const { path, at } = JSON.parse(raw)
    return typeof path === 'string' && path.startsWith('/') && Date.now() - at < 864e5 ? path : null
  } catch { return null }
}
